import { SCORECARD_TAGS } from "../common.js";
import { xCardScorecardApi } from "../api.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const xCardInsightsHooks = xCardScorecardApi.injectEndpoints({
  endpoints: (builder) => ({
    getInsights: builder.query({
      query: ({ payload, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/insights` : `/insights`,
          body: payload,
          method: "POST"
        };
      },
      providesTags: (result, error, { cacheKey }) => [{ type: SCORECARD_TAGS.XCARD_INSIGHTS, cacheKey }]
    }),
    getScorecardInsights: builder.query({
      query: ({ payload, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/scorecardInsights` : `/scorecardInsights`,
          body: payload,
          method: "POST"
        };
      },
      providesTags: (result, error, { cacheKey }) => [{ type: SCORECARD_TAGS.XCARD_SCORECARD_INSIGHTS, cacheKey }]
    })
  })
});
const { usePrefetch: usexCardInsightsApiPrefetch, useGetInsightsQuery, useGetScorecardInsightsQuery } = xCardInsightsHooks;
export {
  useGetInsightsQuery,
  useGetScorecardInsightsQuery,
  usexCardInsightsApiPrefetch,
  xCardInsightsHooks
};
//# sourceMappingURL=insights.js.map
